// Chemin: C:\gestion-copro\src\services\crm.seed.ts
// Session 191 : Cartographie complète 18 prospects — Tier 1 (multiplicateurs nationaux + antennes régionales) + Tier 2 (médias & prescripteurs)
// Session 192 : Ajout champ tier (SegmentProspect) sur chaque prospect
// Session 193 : tier (1|2|3) → segment (multiplicateur/prescripteur/direct)
// Coordonnées à enrichir par téléphone

import { creerProspect } from './crm.service';
import type { SegmentProspect, TypeProspect, TypeCibleProspect } from '../types/crm.types';

export const PROSPECTS_INITIAUX: Array<{
  nom: string;
  typeProspect: TypeProspect;
  typeCible: TypeCibleProspect;
  segment: SegmentProspect;
  responsable: string;
  contactNom: string;
  contactEmail: string;
  contactTelephone: string;
  adresse: string;
  siteWeb: string;
  source?: string;
  noteInitiale?: string;
  problematiques: string[];
  objectifContact: string;
  prochaineAction?: string;
  tailleStructure: string;
}> = [

  // ─────────────────────────────────────────────
  // TIER 1 — MULTIPLICATEURS NATIONAUX
  // ─────────────────────────────────────────────

  {
    nom: 'ARC / UNARC',
    typeProspect: 'association' as const,
    typeCible: 'cs_sentinelle' as const,
    segment: 'ambassadeur',
    responsable: 'dominique',
    contactNom: 'M. Levrel',
    contactEmail: '',
    contactTelephone: '',
    adresse: 'Paris (national)',
    siteWeb: 'https://arc-copro.fr',
    source: 'Contact existant Dominique',
    noteInitiale: 'Priorité absolue. Principale association CS et syndics bénévoles en France — 16 000+ immeubles adhérents. Contact Levrel déjà établi par Dominique. Objectif : partenariat — ARC recommande Copro Protect à ses adhérents CS.',
    problematiques: ['Adhérents CS démunis face aux syndics professionnels', 'Besoin d\'outils pratiques pour le contrôle et la correspondance'],
    objectifContact: 'Partenariat de recommandation — ARC cite Copro Protect dans sa communication aux adhérents',
    tailleStructure: '16 000+ immeubles adhérents',
  },

  {
    nom: 'ANCC',
    typeProspect: 'association' as const,
    typeCible: 'cs_sentinelle' as const,
    segment: 'ambassadeur',
    responsable: 'dominique',
    contactNom: '',
    contactEmail: '',
    contactTelephone: '',
    adresse: '37 rue Jean Leclaire, 75017 Paris',
    siteWeb: 'https://www.ancc.fr',
    source: 'Recherche web',
    noteInitiale: 'Association Nationale de la Copropriété et des Copropriétaires — depuis 1980. 1 750 syndicats adhérents, 65 000 logements. 80% gérés par syndics bénévoles = cœur de cible CS. Spécialisée formation et assistance comptable bénévoles. SENTINELLE répond directement à leurs besoins.',
    problematiques: ['Syndics bénévoles sans outils de gestion', 'Vérification comptable complexe sans expertise', 'Correspondance juridique avec syndics professionnels'],
    objectifContact: 'Partenariat formation — ANCC intègre Copro Protect dans ses recommandations aux syndics bénévoles',
    tailleStructure: '1 750 syndicats, 65 000 logements',
  },

  {
    nom: 'AFCopro',
    typeProspect: 'association' as const,
    typeCible: 'cs_sentinelle' as const,
    segment: 'ambassadeur',
    responsable: 'alain',
    contactNom: '',
    contactEmail: '',
    contactTelephone: '',
    adresse: 'Sud de la France (national)',
    siteWeb: 'https://www.afcopro.com',
    source: 'Recherche web',
    noteInitiale: 'Association Française des Copropriétaires — depuis 1999. Accompagne CS, syndics bénévoles, collectifs, ASL. Adhésion à partir de 199€. Excellent taux Google. Mentionne explicitement sur son site l\'accompagnement par tous moyens. Profil idéal pour partenariat outil numérique.',
    problematiques: ['CS et syndics bénévoles qui cherchent de l\'aide pratique', 'Accompagnement personnalisé difficile à scaler'],
    objectifContact: 'Partenariat — AFCopro recommande Copro Protect à ses adhérents comme outil complémentaire',
    tailleStructure: 'National, adhésion 199€+',
  },

  {
    nom: 'UNPI Nationale',
    typeProspect: 'association' as const,
    typeCible: 'vigie' as const,
    segment: 'ambassadeur',
    responsable: 'dominique',
    contactNom: '',
    contactEmail: '',
    contactTelephone: '01 44 11 32 42',
    adresse: 'Paris (national)',
    siteWeb: 'https://www.unpi.org',
    source: 'Recherche web',
    noteInitiale: 'Union Nationale des Propriétaires Immobiliers — 250 000 adhérents, 120 associations locales depuis 1893. Défend propriétaires et copropriétaires. Cible VIGIE directe : propriétaires bailleurs copropriétaires. Un accord national UNPI = accès à 120 antennes simultanément. Jackpot stratégique.',
    problematiques: ['Propriétaires bailleurs exposés sans protection dans leur copropriété', 'Complexité fiscale et juridique pour les bailleurs'],
    objectifContact: 'Accord-cadre national — tarif préférentiel adhérents UNPI + communication dans leur réseau de 120 associations',
    tailleStructure: '250 000 adhérents, 120 associations locales',
  },

  {
    nom: 'CLCV — Pôle Copropriété',
    typeProspect: 'association' as const,
    typeCible: 'vigie' as const,
    segment: 'ambassadeur',
    responsable: 'dominique',
    contactNom: '',
    contactEmail: '',
    contactTelephone: '',
    adresse: 'Paris (national)',
    siteWeb: 'https://www.clcv.org/categories/coproprietaires',
    source: 'Recherche web',
    noteInitiale: 'Consommation Logement Cadre de Vie — association de consommateurs avec pôle copropriété dédié (FEDECO). Dénonce activement les abus des syndics dans sa communication. Copro Protect est l\'outil concret qu\'ils recommandent naturellement. Présents au Salon de la Copropriété chaque année.',
    problematiques: ['Copropriétaires victimes d\'abus syndics sans moyen d\'agir', 'Manque d\'outils accessibles pour documenter et contester'],
    objectifContact: 'Partenariat recommandation — CLCV cite Copro Protect comme solution pour ses adhérents copropriétaires',
    tailleStructure: 'National — association consommateurs reconnue',
  },

  {
    nom: 'AAPC France',
    typeProspect: 'association' as const,
    typeCible: 'vigie' as const,
    segment: 'ambassadeur',
    responsable: 'dominique',
    contactNom: '',
    contactEmail: '',
    contactTelephone: '',
    adresse: 'National',
    siteWeb: 'https://www.aapcfrance.com',
    source: 'Recherche web',
    noteInitiale: 'Association d\'Aide aux Propriétaires et Copropriétaires. Accompagne propriétaires occupants, bailleurs, CS, syndics bénévoles, ASL, SCI. Droits d\'entrée 50€ + cotisation 87-200€/an. Cible très large qui recoupe exactement notre marché VIGIE et CS. Profil complémentaire à UNPI.',
    problematiques: ['Propriétaires et copropriétaires sans accompagnement juridique et technique accessible', 'Gestion copropriété complexe pour les non-spécialistes'],
    objectifContact: 'Partenariat recommandation — AAPC intègre Copro Protect dans ses outils recommandés aux adhérents',
    tailleStructure: 'National',
  },

  {
    nom: 'SYNDEC',
    typeProspect: 'association' as const,
    typeCible: 'vigie' as const,
    segment: 'ambassadeur',
    responsable: 'dominique',
    contactNom: '',
    contactEmail: '',
    contactTelephone: '',
    adresse: 'National',
    siteWeb: 'https://www.syndec.fr',
    source: 'Recherche web',
    noteInitiale: 'Syndicat National de Défense des Propriétaires et Copropriétaires. Réseau d\'experts (avocats, architectes, comptables, géomètres). Positionnement défense des droits = aligné avec Copro Protect. À qualifier — vérifier activité réelle avant premier contact.',
    problematiques: ['Propriétaires et copropriétaires en besoin de défense de leurs droits'],
    objectifContact: 'Qualifier l\'activité réelle, puis partenariat prescripteur via leur réseau d\'experts',
    tailleStructure: 'À qualifier',
  },

  {
    nom: 'FEDECO — Fédération de Défense des Copropriétaires',
    typeProspect: 'association' as const,
    typeCible: 'vigie' as const,
    segment: 'ambassadeur',
    responsable: 'dominique',
    contactNom: '',
    contactEmail: '',
    contactTelephone: '',
    adresse: 'Paris (national)',
    siteWeb: 'https://www.clcv.org',
    source: 'Recherche web',
    noteInitiale: 'Émanation de la CLCV créée en 1990, spécialisée copropriétaires. Aborde le copropriétaire comme un consommateur — posture identique à VIGIE. Rattachée à CLCV mais autonome sur le sujet copropriété. Contact à établir via CLCV dans un premier temps.',
    problematiques: ['Copropriétaires considérés comme consommateurs mal protégés face aux syndics'],
    objectifContact: 'Approche via CLCV national — identifier le responsable FEDECO et proposer partenariat',
    tailleStructure: 'National, affiliée CLCV',
  },

  // ─────────────────────────────────────────────
  // TIER 1 — ANTENNES RÉGIONALES
  // ─────────────────────────────────────────────

  {
    nom: 'ARC Hauts-de-France',
    typeProspect: 'association' as const,
    typeCible: 'cs_sentinelle' as const,
    segment: 'recommandeur',
    responsable: 'alain',
    contactNom: '',
    contactEmail: '',
    contactTelephone: '',
    adresse: 'Lille / Dunkerque',
    siteWeb: 'https://www.arc-hautsdefrance.fr',
    source: 'Recherche web — antenne régionale ARC',
    noteInitiale: 'Antenne régionale ARC. Permanences à Lille et Dunkerque. Territoire naturel d\'Alain. Porte d\'entrée régionale avant négociation nationale ARC. Approche digitale uniquement.',
    problematiques: ['CS locaux sans outils numériques adaptés'],
    objectifContact: 'Premier contact régional — référence locale avant approche ARC national',
    tailleStructure: 'Antenne régionale ARC',
  },

  {
    nom: 'UNPI Nord (59-62)',
    typeProspect: 'association' as const,
    typeCible: 'vigie' as const,
    segment: 'recommandeur',
    responsable: 'alain',
    contactNom: '',
    contactEmail: '',
    contactTelephone: '',
    adresse: 'Nord — Pas-de-Calais',
    siteWeb: 'https://unpi5962.org',
    source: 'Recherche web',
    noteInitiale: 'Antenne UNPI couvrant le territoire de Dominique et Alain. Cible propriétaires bailleurs = VIGIE direct. Proximité géographique d\'Alain. Porte d\'entrée régionale vers accord national UNPI. Proposer tarif préférentiel adhérents.',
    problematiques: ['Propriétaires bailleurs du Nord sans outil de protection copropriété'],
    objectifContact: 'Accord régional pilote — tarif adhérents UNPI 59-62, puis remontée vers UNPI nationale',
    tailleStructure: 'Antenne régionale UNPI — 120 associations nationales',
  },

  {
    nom: 'ARC Rhône-Alpes (ARCC AURA)',
    typeProspect: 'association' as const,
    typeCible: 'cs_sentinelle' as const,
    segment: 'recommandeur',
    responsable: 'dominique',
    contactNom: '',
    contactEmail: '',
    contactTelephone: '',
    adresse: 'Lyon / Auvergne-Rhône-Alpes',
    siteWeb: 'https://www.arcrhonealpes.com',
    source: 'Recherche web — antenne régionale ARC',
    noteInitiale: 'Antenne ARC AURA. Mentionne explicitement sur son site la "conclusion de partenariats avec des entreprises en lien avec le monde de la copropriété". Signal fort — porte ouverte identifiée. Approche 100% digitale.',
    problematiques: ['CS en Rhône-Alpes cherchant des partenariats outils'],
    objectifContact: 'Partenariat explicitement recherché par cette antenne — angle d\'attaque direct',
    tailleStructure: 'Antenne régionale ARC — région dense en copropriétés',
  },

  {
    nom: 'UNPI Île-de-France',
    typeProspect: 'association' as const,
    typeCible: 'vigie' as const,
    segment: 'recommandeur',
    responsable: 'dominique',
    contactNom: '',
    contactEmail: '',
    contactTelephone: '',
    adresse: 'Paris / Île-de-France',
    siteWeb: 'https://www.unpi.org',
    source: 'Recherche web',
    noteInitiale: 'Antenne UNPI IDF — région la plus dense en copropriétés de France. Relais naturel après accord UNPI national. Volume potentiel d\'adhérents VIGIE considérable. Approche digitale uniquement.',
    problematiques: ['Propriétaires bailleurs IDF surexposés aux problèmes de copropriété'],
    objectifContact: 'Relais régional après accord national UNPI — ou entrée directe si nationale trop longue',
    tailleStructure: 'Antenne régionale UNPI — région la plus dense',
  },

  {
    nom: 'UNPI PACA',
    typeProspect: 'association' as const,
    typeCible: 'vigie' as const,
    segment: 'recommandeur',
    responsable: 'dominique',
    contactNom: '',
    contactEmail: '',
    contactTelephone: '',
    adresse: 'Marseille / Aix / Nice',
    siteWeb: 'https://www.unpi.org',
    source: 'Recherche web',
    noteInitiale: 'Antenne UNPI PACA — 2e région la plus dense en copropriétés après IDF. Fort taux de propriétaires bailleurs. Approche digitale uniquement.',
    problematiques: ['Propriétaires bailleurs PACA sans outil de protection adapté'],
    objectifContact: 'Relais régional après accord national UNPI',
    tailleStructure: 'Antenne régionale UNPI — 2e région française en copropriétés',
  },

  // ─────────────────────────────────────────────
  // TIER 2 — MÉDIAS & PRESCRIPTEURS
  // ─────────────────────────────────────────────

  {
    nom: 'Informations Rapides de la Copropriété (IRC)',
    typeProspect: 'prescripteur' as const,
    typeCible: 'cs_sentinelle' as const,
    segment: 'client_direct',
    responsable: 'dominique',
    contactNom: '',
    contactEmail: '',
    contactTelephone: '',
    adresse: 'Paris (national)',
    siteWeb: 'https://www.informationsrapidesdelacopropriete.fr',
    source: 'Recherche web',
    noteInitiale: 'Mensuel de référence de la copropriété depuis 1963. Lu par tous les CS professionnels, syndics, juristes. Un article ou un encart dans IRC = crédibilité immédiate auprès de notre cœur de cible CS. Organisent aussi des formations et partenaires du Salon SOLUCOP.',
    problematiques: ['Lecteurs CS cherchant des outils pratiques innovants'],
    objectifContact: 'Article de présentation ou partenariat éditorial — Copro Protect présenté comme solution innovante pour les CS',
    tailleStructure: 'Mensuel national, lectorat professionnel copropriété',
  },

  {
    nom: 'Monimmeuble.com',
    typeProspect: 'prescripteur' as const,
    typeCible: 'vigie' as const,
    segment: 'client_direct',
    responsable: 'dominique',
    contactNom: '',
    contactEmail: '',
    contactTelephone: '',
    adresse: 'En ligne (national)',
    siteWeb: 'https://monimmeuble.com',
    source: 'Recherche web',
    noteInitiale: 'Magazine web copropriété — fort trafic grand public copropriétaire. Couvre charges, travaux, syndics, DPE, rénovation. Audience cible VIGIE exacte : copropriétaire lambda qui cherche des infos pratiques. Partenariat article sponsorisé ou test produit.',
    problematiques: ['Lecteurs copropriétaires cherchant des solutions concrètes'],
    objectifContact: 'Article test ou partenariat contenu — Copro Protect présenté à leur audience de copropriétaires',
    tailleStructure: 'Média web national, trafic grand public',
  },

  {
    nom: 'ANGC — Assoc. Nationale Gestionnaires Copropriété',
    typeProspect: 'association' as const,
    typeCible: 'cs_sentinelle' as const,
    segment: 'client_direct',
    responsable: 'dominique',
    contactNom: 'Julien Sevenier',
    contactEmail: '',
    contactTelephone: '',
    adresse: 'National',
    siteWeb: 'https://angc-association.fr',
    source: 'Recherche web',
    noteInitiale: 'Association des gestionnaires de copropriété — canal B2B syndics professionnels et bénévoles. Contact identifié : Julien Sevenier (rédacteur/actif sur le site). Cible offre CS SENTINELLE et au-delà. Réseau de syndics qui pourraient recommander Copro Protect à leurs CS.',
    problematiques: ['Gestionnaires cherchant des outils pour accompagner leurs CS'],
    objectifContact: 'Partenariat prescripteur — ANGC recommande Copro Protect aux CS de leurs adhérents gestionnaires',
    tailleStructure: 'National — réseau gestionnaires copropriété',
  },

  {
    nom: 'SOLUCOP — Salon de la Copropriété',
    typeProspect: 'prescripteur' as const,
    typeCible: 'cs_sentinelle' as const,
    segment: 'client_direct',
    responsable: 'alain',
    contactNom: '',
    contactEmail: '',
    contactTelephone: '',
    adresse: 'Strasbourg (mars), Toulouse (avril), Lille (oct), Nice (nov)',
    siteWeb: 'https://www.informationsrapidesdelacopropriete.fr',
    source: 'Recherche web — IRC partenaire',
    noteInitiale: 'Salon itinérant copropriété organisé par IRC. 2026 : Strasbourg 19 mars, Toulouse 2 avril, Lille 8 octobre, Nice nov. Alain peut couvrir Lille (8 octobre 2026) — présence physique justifiée car événement professionnel. Networking avec toutes les associations Tier 1.',
    problematiques: ['CS et syndics cherchant des solutions innovantes lors de salons professionnels'],
    objectifContact: 'Présence comme exposant ou partenaire à Lille oct 2026 — démonstration live SENTINELLE',
    tailleStructure: 'Événement itinérant — 4 dates en 2026',
  },

  {
    nom: 'Salon de la Copropriété et de l\'Habitat — Paris',
    typeProspect: 'prescripteur' as const,
    typeCible: 'cs_bouclier' as const,
    segment: 'client_direct',
    responsable: 'dominique',
    contactNom: '',
    contactEmail: '',
    contactTelephone: '',
    adresse: 'Paris — Porte de Versailles',
    siteWeb: 'https://www.informationsrapidesdelacopropriete.fr',
    source: 'Recherche web',
    noteInitiale: 'L\'événement de référence annuel copropriété — 4 et 5 novembre 2026, Porte de Versailles. Toutes les associations Tier 1 présentes. Possibilité stand ou démo live. Objectif : se faire connaître de l\'écosystème complet en 2 jours. Budget stand à anticiper.',
    problematiques: ['Toutes les cibles réunies en un même lieu'],
    objectifContact: 'Stand exposant ou présentation — démonstration SENTINELLE live pour CS et associations',
    tailleStructure: 'Événement annuel national — référence du secteur',
  },
];

/**
 * Charger les 18 prospects en base Firestore.
 * Session 191 — cartographie complète Tier 1 + Tier 2.
 */
export const seedProspectsInitiaux = async (): Promise<number> => {
  let count = 0;

  for (const prospect of PROSPECTS_INITIAUX) {
    try {
      await creerProspect(prospect);
      count++;
      console.log(`[CRM Seed] ✓ ${prospect.nom}`);
    } catch (error) {
      console.error(`[CRM Seed] ✗ ${prospect.nom}:`, error);
    }
  }

  console.log(`[CRM Seed] ${count}/${PROSPECTS_INITIAUX.length} prospects créés`);
  return count;
};
